<template>
    <v-btn
        v-if="downloadUrl"
        ref="download"
        :href="downloadUrl"
        :disabled="isDisabled"
        color="accent"
        class="text-caption"
        @click.prevent="handleClick"
    >
        <v-icon v-if="btnIcon !== ''" class="mr-2" color="white" small> {{ btnIcon }} </v-icon>
        <span class="button-label">
            {{ $t(labelText) }}
        </span>
    </v-btn>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import downloader from '../../utils/blob_download';

@Component({
    name: 'ButtonDownLoad',
})
export default class ButtonDownLoad extends Vue {
    @Prop({ default: () => 'save_alt' }) icon: string;
    @Prop({ default: () => 'Download' }) label: string;
    @Prop({ default: () => '' }) downloadUrl: string;
    @Prop({ default: false }) disabled: boolean;

    get isDisabled(): boolean {
        return this.disabled;
    }
    get labelText(): string {
        return this.label;
    }
    get btnIcon(): string {
        return this.icon;
    }

    /**
     * methods
     */
    handleClick(id: number) {
        /**
         * javascriptによるダウンロード処理は、ブラウザの制限により、クリックイベントのコンテキストでしか実行できない
         * vuexの非同期処理を経由すると、API呼び出しが別のコンテキストで実行されてしまうので、
         * ここでは、vuexを使わず直接APIを呼び出す
         */
        this.$emit('download-start');
        downloader
            .get(this.$store, this.downloadUrl, response => {
                const blob = response.data;
                const fileName = decodeURIComponent(response.headers['x-aries-download-file-name']);

                if (window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(blob, fileName);
                } else {
                    let anchor = document.createElement('a');
                    anchor.setAttribute('style', 'display:none;');
                    anchor.href = window.URL.createObjectURL(blob);
                    anchor.download = fileName;
                    document.body.appendChild(anchor);
                    anchor.click();
                    document.body.removeChild(anchor);
                }
            })
            .then(() => {
                this.$emit('download-success');
            })
            .catch(e => {
                this.$emit('download-failure', e);
            });
        return false;
    }
}
</script>

<style lang="scss" scoped>
.button-label {
    font-weight: bolder;
}
</style>
